import { createElement } from "react";
import { Link2, Target } from "lucide-react";
import {
  CausalChainParamsSchema,
  defaultCausalChainParams,
  WIDGET_LABELS,
  type CausalChainParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { CausalChainWidget } from "./Component.js";
import { CausalChainExpandedEditor } from "./ExpandedEditor.js";

export const causalChainDef: WidgetDef<CausalChainParams> = {
  kind: "causalChain",
  label: WIDGET_LABELS.causalChain,
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 352, h: 724 },
  defaultParams: defaultCausalChainParams,
  Component: CausalChainWidget,
  ExpandedComponent: CausalChainExpandedEditor,
  storage: "sql",
  schema: CausalChainParamsSchema,
  accent: "emerald",
  icon: Link2,
  subtitle: "Successive why questions",
  defaultRoster: true,
  category: "multi",
  layout: { col: 1, row: 1, width: 352, height: 700 },
  expandable: true,
  renderSubtitle: (data) =>
    data.problem ? `Why? · ${data.problem}` : "Successive why questions",
  renderFooter: (data) => ({
    left: `${data.steps.length} step${data.steps.length === 1 ? "" : "s"}`,
    right: data.steps.some((s) => s.isRoot)
      ? createElement(
          "span",
          {
            className:
              "inline-flex items-center gap-1 text-pb-green-text font-medium",
          },
          createElement(Target, { className: "w-3 h-3", "aria-hidden": true }),
          " Root marked",
        )
      : "",
  }),
};

registerWidget(causalChainDef);
